import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../utils';
import { TypographyProps } from '@mui/material';
import LBTLabel from '../Label';

export type LBTButtonFilterProps = ButtonProps & {
  onClick: () => void;
  isSelected: boolean;
  isGrey?: boolean;
  noBorderRadius?: boolean;
  datatestid?: string;
  textProps?: TypographyProps;
};

const getBackGoundColor = (isSelected: boolean, isGrey: boolean) => {
  if (isSelected) {
    if (isGrey) {
      return COLORS.getInstance().BW_GREYS_SUPERLIGHT;
    }
    return COLORS.getInstance().PRIMARY_DARK;
  }
  return COLORS.getInstance().WHITE;
};

const getColor = (isSelected: boolean, isGrey: boolean) => {
  if (isGrey) {
    return COLORS.getInstance().BW_GREYS_DARK;
  }
  if (isSelected) {
    return COLORS.getInstance().PRIMARY_IPERLIGHT;
  }
  return COLORS.getInstance().PRIMARY_DARK;
};

const StyledButtonFilter = styled(Button)<
  ButtonProps & {
    datatestid: string;
    'data-track': string;
    isSelected: boolean;
    isGrey?: boolean;
    noBorderRadius?: boolean;
  }
>(({
  datatestid,
  isSelected = false,
  color,
  isGrey = false,
  noBorderRadius = false,
  ...props
}) => {
  return {
    datatestid,
    'data-track': props['data-track'],

    '&.MuiButton-root': {
      backgroundColor: getBackGoundColor(isSelected, isGrey),
      borderColor: getBackGoundColor(isSelected, isGrey),
      borderWidth: '1px',
      borderRadius: noBorderRadius ? 0 : '10px',

      '.MuiTypography-root': {
        color: getColor(isSelected, isGrey),
      },
    },

    '& .MuiButton-startIcon > svg:first-child': {
      filter: props.disabled ? 'contrast(0%)' : 'contrast(100%)',
    },
    '& .MuiButton-endIcon > svg:last-child': {
      filter: props.disabled ? 'contrast(0%)' : 'contrast(100%)',
    },
  };
});

const LBTButtonFilter: React.FC<LBTButtonFilterProps> = ({
  datatestid = '',
  children,
  textProps,
  size,
  ...props
}: LBTButtonFilterProps) => {
  const getVariant = () => {
    if (size === 'small') return 'buttonSmall';
    if (size === 'medium') return 'buttonMedium';
    return 'buttonLarge';
  };

  return (
    <StyledButtonFilter
      datatestid={`lbt-button-filter-${datatestid}`}
      data-track={datatestid}
      variant="outlined"
      color="primary"
      size={size}
      {...props}
    >
      <LBTLabel
        datatestid={`lbt-button-filter-label-${datatestid}`}
        data-track={datatestid}
        {...textProps}
        variant={getVariant()}
      >
        {children}
      </LBTLabel>
    </StyledButtonFilter>
  );
};

export default LBTButtonFilter;
